import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/layout/UrgencyBanner';
import { Header } from './components/layout/Header';
import { SiteFooter } from './components/layout/SiteFooter';
import { Home } from './pages/Home';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="flex min-h-screen w-full flex-col bg-ivory" data-id="element-0" data-mp="2rkx3hddxwbly">
      <div className="sticky top-0 z-40" data-id="element-1" data-mp="2rl6un4aq0ot8">
        <UrgencyBanner data-id="element-2" data-mp="2mm2o6lf6l56l" />
        <Header data-id="element-3" data-mp="2mmvkstkfeeb0" />
      </div>
      <div className="flex-1" data-id="element-4" data-mp="2mnnhk7prei2v">
        <Home data-id="element-5" data-mp="31aqd48uiugnk" />
      </div>
      <SiteFooter data-id="element-6" data-mp="31aysc7e49y1x" />
    </div>;
}